<template>
  <span class="text-no-wrap">
     <slot name="clockIn" v-bind:item="item">
      {{getClockInTime(item) }}
    </slot>
  </span>
</template>

<script>
import DateTimeUtil from '@/util/date-time-util';
import getActualStartOrEndTime from '@/mixins/timepairs/getActualStartOrEndTime';

export default {
  name: 'StartTimeTableCell',
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  mixins: [getActualStartOrEndTime],
  methods: {
    getClockInTime(timePair) {
      const timeEntry = this.getActualStartTime(timePair);
      return DateTimeUtil.convertDateTimeToHumanReadableTime(timeEntry.date);
    },
  },
};
</script>
